import {reducer} from './helpers'
import {SAVE_BILLING_ADDRESS_SUCCESS} from '../actions/checkout'
import {SAVE_RTK_BILLING_INFORMATION_SUCCESS} from '../actions/rentToKeep'
import {
  FETCH_PAYPAGE_REGISTRATION_ID_FAILURE,
  FETCH_PAYPAGE_REGISTRATION_ID_PENDING,
  FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS,
  RESET_VALUES,
} from '../actions/worldpay'

const initialState = {
  expMonth: null,
  expYear: null,
  isPending: false,
  paypageRegistrationId: null,
}

export default reducer(initialState, (state, action) => {
  switch (action.type) {
    case SAVE_BILLING_ADDRESS_SUCCESS:
    case SAVE_RTK_BILLING_INFORMATION_SUCCESS:
      return {...initialState}
    case FETCH_PAYPAGE_REGISTRATION_ID_PENDING:
      return {
        isPending: true,
      }
    case FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS:
      return {
        expMonth: action.payload.expMonth,
        expYear: action.payload.expYear,
        isPending: false,
        paypageRegistrationId: action.payload.paypageRegistrationId,
      }
    case FETCH_PAYPAGE_REGISTRATION_ID_FAILURE:
      return {
        isPending: false,
      }
    case RESET_VALUES:
      return {...initialState}
    default:
      return null
  }
})
